import { render, staticRenderFns } from "./palm0.vue?vue&type=template&id=0b847c1a&scoped=true&"
import script from "./palm0.vue?vue&type=script&lang=js&"
export * from "./palm0.vue?vue&type=script&lang=js&"
import style0 from "./palm0.vue?vue&type=style&index=0&id=0b847c1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b847c1a",
  null
  
)

export default component.exports